import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { IonIcon, IonSpinner } from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'yt-processing-overlay',
  templateUrl: 'processing-overlay.html',
  styleUrls: ['processing-overlay.scss'],
  imports: [IonSpinner, IonIcon, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProcessingOverlay {
  readonly title = input.required<string>();
  readonly description = input<string | null>(null);
}
